import { faAnchor, faColumns, faTable } from "@fortawesome/free-solid-svg-icons";
import ToolbarButton from "../../../components/ToolbarButton";
import { INSERT_MEDIA_COMMAND } from "../../MediaPlugin";
import { INSERT_TABLE_COMMAND } from '@lexical/table';
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { INSERT_LAYOUT_COMMAND } from "../../LayoutPlugin/LayoutPlugin";
import ModalWithFinalForm from "../../../../modals/ModalWithFinalForm";
import { Row } from "reactstrap";
import { SetStateAction, useState } from "react";
import FormFieldTextOrNumber from "../../../../formFields/FormFieldTextOrNumber";
import { useIntl } from "react-intl";
import FormFieldWithDropdown from "../../../../formFields/FormFieldWithDropdown";

export function Table()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleSubmit = (formData: { columns: string, rows: string }) =>
    {
        editor.dispatchCommand(INSERT_TABLE_COMMAND, formData);
        setIsModalOpen(false);
    };
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.tableModal;
    const buttons =
    {
        confirm: { color: 'success', label: translations?.confirm ?? 'OK' },
        cancel: { color: 'danger', label: translations?.cancel ?? 'Cancel' }
    };
    const element =
    <>
        <button type="button" className="btn" onClick={() => setIsModalOpen(true)}>
            <FontAwesomeIcon icon={faTable} />
        </button>
        {isModalOpen && <ModalWithFinalForm isOpen={isModalOpen} initialValues={{ columns: 5, rows: 5 }}
            setIsOpen={setIsModalOpen}
            onConfirm={handleSubmit}
            header={translations?.header ?? 'Table'}
            buttons={buttons}
            modalBody=
            {<>
                {/* <Alert color='danger' isOpen={isAlertOpen} toggle={() => setIsAlertOpen(false)} >
                    <span>{alertMessage}</span>
                </Alert> */}
                <Row className='my-2 d-flex flex-column '>
                    <FormFieldTextOrNumber type='number' className="w-100" name='columns' label={translations?.columns ?? 'Columns'} />
                </Row>
                <Row className='my-2'>
                    <FormFieldTextOrNumber type='number' className="w-100" name='rows' label={translations?.rows ?? 'Rows'} />
                </Row>
            </>}
        />}
    </>;
    return element;
}